// utils/validationSchemas.js
import * as Yup from 'yup';

export const stepValidations = {
  'Session name inclusion notification': Yup.object().shape({
    client_name: Yup.string().required('Client Name is required'),
    conference_name: Yup.string().required('Conference Name is required'),
    conference_short_name: Yup.string().required(
      'Conference Short Name is required'
    ),
    conference_organizer: Yup.string().required(
      'Conference Organizer is required'
    ),
    conference_from_date: Yup.date()
      .transform((value, originalValue) => {
        return originalValue ? new Date(originalValue) : null;
      })
      .required('Conference From Date is required'),

    conference_to_date: Yup.date()
      .transform((value, originalValue) => {
        return originalValue ? new Date(originalValue) : null;
      })
      .required('Conference To Date is required')
      .min(
        Yup.ref('conference_from_date'),
        'To Date cannot be before From Date'
      ),

    conference_location: Yup.string().required(
      'Conference Location is required'
    ),
    session_title: Yup.string().required('Session Title is required'),
    brief_overview: Yup.string().required('Brief Overview is required'),
    paper_title: Yup.string().required('Paper Title is required'),
    relevant_field: Yup.string().required('Relevant Field is required'),
    specific_sdg_goal_numbers: Yup.string().required(
      'SDG Goal Number is required'
    ),
    your_name: Yup.string().required('Your Name is required'),
    contact_details: Yup.string().required('Contact Details are required'),
  }),

  'Coupon or Voucher follow ups/early bird deadline': Yup.object().shape({
    client_name: Yup.string().required('Client Name is required'),
    conference_short_name: Yup.string().required(
      'Conference Short Name is required'
    ),
    conference_from_date: Yup.date()
      .transform((value, originalValue) => {
        return originalValue ? new Date(originalValue) : null;
      })
      .required('Conference From Date is required'),

    conference_to_date: Yup.date()
      .transform((value, originalValue) => {
        return originalValue ? new Date(originalValue) : null;
      })
      .required('Conference To Date is required')
      .min(
        Yup.ref('conference_from_date'),
        'To Date cannot be before From Date'
      ),
    conference_location: Yup.string().required(
      'Conference Location is required'
    ),
    coupon_code: Yup.string().required('Coupon Code is required'),
    registration_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Registration Link is required'),
    your_name: Yup.string().required('Your Name is required'),
    contact_details: Yup.string().required('Contact Details are required'),
  }),

  'Publication Details Few slots left': Yup.object().shape({
    client_name: Yup.string().required('Client Name is required'),
    conference_short_name: Yup.string().required(
      'Conference Short Name is required'
    ),
    conference_from_date: Yup.date()
      .transform((value, originalValue) =>
        originalValue ? new Date(originalValue) : null
      )
      .required('Conference From Date is required'),
    conference_to_date: Yup.date()
      .transform((value, originalValue) =>
        originalValue ? new Date(originalValue) : null
      )
      .required('Conference To Date is required')
      .min(
        Yup.ref('conference_from_date'),
        'To Date cannot be before From Date'
      ),
    conference_location: Yup.string().required(
      'Conference Location is required'
    ),
    paper_title: Yup.string().required('Paper Title is required'),
    journals: Yup.array()
      .of(
        Yup.object().shape({
          journal_name: Yup.string().required('Journal name is required'),
        })
      )
      .min(1, 'At least one journal is required'),
    isbn_number: Yup.string().required('ISBN Number is required'),
    your_name: Yup.string().required('Your Name is required'),
    contact_details: Yup.string().required('Contact Details are required'),
  }),

  'Session-Based Publication Opportunities and Conference Outcomes at [Conference Name]':
    Yup.object().shape({
      client_name: Yup.string().required('Client Name is required'),
      paper_title: Yup.string().required('Paper Title is required'),
      conference_name: Yup.string().required('Conference Name is required'),

      conference_from_date: Yup.date()
        .transform((value, originalValue) =>
          originalValue ? new Date(originalValue) : null
        )
        .required('Conference From Date is required'),

      conference_to_date: Yup.date()
        .transform((value, originalValue) =>
          originalValue ? new Date(originalValue) : null
        )
        .required('Conference To Date is required')
        .min(
          Yup.ref('conference_from_date'),
          'To Date cannot be before From Date'
        ),

      conference_location: Yup.string().required(
        'Conference Location is required'
      ),

      registration_link: Yup.string()
        .url('Must be a valid URL (e.g., https://example.com)')
        .required('Registration Link is required'),

      sdg_name_number: Yup.string().required('SDG Name/Number is required'),
      sdg_brif_explanation: Yup.string().required(
        'SDG Brief Explanation is required'
      ),

      your_name: Yup.string().required('Your Name is required'),

      contact_details: Yup.string().required('Contact Details are required'),
    }),

  'Keynote speaker, session speaker notification': Yup.object().shape({
    client_name: Yup.string().required('Client Name is required'),
    conference_name: Yup.string().required('Conference Name is required'),
    conference_date: Yup.date()
      .transform((value, originalValue) =>
        originalValue ? new Date(originalValue) : null
      )
      .required('Conference Date is required'),

    conference_location: Yup.string().required(
      'Conference Location is required'
    ),
    featured_speakers: Yup.array()
      .of(
        Yup.object().shape({
          speaker_name: Yup.string().required('Speaker Name is required'),
          speaker_credentials: Yup.string().required(
            'Speaker Credentials are required'
          ),
          speaker_achievements: Yup.string().required(
            'Speaker Achievements are required'
          ),
          speaker_sessionTopic: Yup.string().required(
            'Speaker Session Topic is required'
          ),
        })
      )
      .min(1, 'At least one speaker is required'),

    registration_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Registration Link is required'),
  }),

  'Agenda Page and Slot Allotment notification': Yup.object().shape({
    client_name: Yup.string().required('Client Name is required'),
    conference_short_name: Yup.string().required(
      'Conference Short Name is required'
    ),
    venue_name: Yup.string().required('Venue Name is required'),
    address: Yup.string().required('Address is required'),
    map_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Map Link is required'),
    zoom_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Zoom Link is required'),
    // registration_date_time: Yup.date()
    //   .typeError('Registration Date & Time is required')
    //   .required('Registration Date & Time is required'),

    registration_date_time: Yup.date()
      .nullable()
      .required('Registration Date is required')
      .test(
        'is-within-date-time-range',
        'Registration Date must be set between the current date and the conference start date.',
        function (value) {
          const { conference_from_date } = this.parent;

          if (!value || !conference_from_date) return true;

          const regDate = new Date(value);
          const startDate = new Date(conference_from_date);
          const currentDate = new Date();

          return regDate >= currentDate && regDate <= startDate;
        }
      ),
    conference_location: Yup.string().required(
      'Conference Location is required'
    ),
    hall_ticket_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Hall Ticket Link is required'),
    your_name: Yup.string().required('Your Name is required'),
    contact_details: Yup.string().required('Contact Details are required'),
  }),

  'Hall Ticket, Zoom link and Confirmation': Yup.object().shape({
    conference_short_name: Yup.string().required(
      'Conference Short Name is required'
    ),
    client_name: Yup.string().required('Client Name is required'),
    venue_name: Yup.string().required('Venue Name is required'),
    full_address: Yup.string().required('Full Address is required'),
    map_link: Yup.string()
      .url('Must be a valid URL (e.g., https://maps.google.com/...)')
      .required('Map Link is required'),
    zoom_link: Yup.string()
      .url('Must be a valid Zoom URL (e.g., https://zoom.us/...)')
      .required('Zoom Link is required'),
    download_zoom: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com/...)')
      .required('Zoom Download Link is required'),
    // registration_date_time: Yup.date()
    //   .typeError('Registration Date & Time must be a valid date')
    //   .required('Registration Date & Time is required'),
    registration_date_time: Yup.date()
      .nullable()
      .required('Registration Date & Time is required')
      .test(
        'is-within-date-time-range',
        'Registration Date must be set between the current date and the conference start date.',
        function (value) {
          const { conference_from_date } = this.parent;

          if (!value || !conference_from_date) return true;

          const regDate = new Date(value);
          const startDate = new Date(conference_from_date);
          const currentDate = new Date();

          return regDate >= currentDate && regDate <= startDate;
        }
      ),
    hall_ticket_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com/...)')
      .required('Hall Ticket Link is required'),
    support_email: Yup.string()
      .email('Must be a valid email (e.g., support@example.com)')
      .required('Support Email is required'),
    support_phone: Yup.string().required('Support Phone is required'),
  }),

  'Full Paper Follow-Up Email': Yup.object().shape({
    conference_short_name: Yup.string().required(
      'Conference Short Name is required'
    ),
    client_name: Yup.string().required('Client Name is required'),
    conference_from_date: Yup.date()
      .transform((value, originalValue) => {
        return originalValue ? new Date(originalValue) : null;
      })
      .required('Conference From Date is required'),

    conference_to_date: Yup.date()
      .transform((value, originalValue) => {
        return originalValue ? new Date(originalValue) : null;
      })
      .required('Conference To Date is required')
      .min(
        Yup.ref('conference_from_date'),
        'To Date cannot be before From Date'
      ),

    conference_location: Yup.string().required(
      'Conference Location is required'
    ),
    // submission_date_line: Yup.date()
    //   .typeError('Submission Deadline must be a valid date')
    //   .required('Submission Deadline is required'),

    submission_date_line: Yup.date()
      .nullable()
      .required('Submission Deadline Date is required')
      .test(
        'is-within-date-range',
        'Submission Deadline must be between current date and the conference start date',
        function (value) {
          const { conference_from_date } = this.parent;

          if (!value || !conference_from_date) return true;
          const regDate = new Date(value).setHours(0, 0, 0, 0);
          const startDate = new Date(conference_from_date).setHours(0, 0, 0, 0);
          const currentDate = new Date().setHours(0, 0, 0, 0);

          return regDate >= currentDate && regDate <= startDate;
        }
      ),
    guideline: Yup.string().required('Guideline is required'),
    submission_full_paper: Yup.string()
      .url(
        'Submission Full Paper must be a valid URL (e.g., https://example.com)'
      )
      .required('Submission Full Paper URL is required'),
    contact_support: Yup.string()
      .email('Support Contact must be a valid email')
      .required('Support Contact is required'),
    your_name: Yup.string().required('Your Name is required'),
    your_title: Yup.string().required('Your Title is required'),
    your_contact_information: Yup.string()
      .required('Your Contact Information is required')
      .matches(
        /^[0-9+\-() ]+$/,
        'Contact Information must be a valid phone number'
      ),
    your_website: Yup.string()
      .url('Website must be a valid URL (e.g., https://example.com)')
      .required('Website is required'),
  }),

  'Conference testimonials email with CPD': Yup.object().shape({
    client_name: Yup.string().required('Client Name is required'),
    conference_short_name: Yup.string().required(
      'Conference Short Name is required'
    ),
    register_link: Yup.string()
      .url('Register Link must be a valid URL (e.g., https://example.com)')
      .required('Register Link is required'),
    video_link: Yup.string()
      .url('Video Link must be a valid URL (e.g., https://example.com)')
      .required('Video Link is required'),
    your_name: Yup.string().required('Your Name is required'),
    contact_details: Yup.string().required('Contact Details are required'),
    // .matches(/^[0-9+\-() ]+$/, 'Contact Details must be a valid phone number'),
  }),
  'Scope of the Research Notification': Yup.object().shape({
    client_name: Yup.string().required('Client Name is required'),
    conference_name: Yup.string().required('Conference Name is required'),
    conference_location: Yup.string().required(
      'Conference Location is required'
    ),
    paper_title: Yup.string().required('Paper Title is required'),
    conference_from_date: Yup.date()
      .transform((value, originalValue) => {
        return originalValue ? new Date(originalValue) : null;
      })
      .required('Conference From Date is required'),

    conference_to_date: Yup.date()
      .transform((value, originalValue) => {
        return originalValue ? new Date(originalValue) : null;
      })
      .required('Conference To Date is required')
      .min(
        Yup.ref('conference_from_date'),
        'To Date cannot be before From Date'
      ),
    specific_topic: Yup.string().required('Specific Topic is required'),
    specific_field: Yup.string().required('Specific Field is required'),
    registration_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Registration Link is required'),
    your_name: Yup.string().required('Your Name is required'),
    contact_details: Yup.string().required('Contact Details are required'),
    // .matches(
    //   /^[0-9+\-() ]+$/,
    //   'Contact Details must be a valid phone number'
    // ),
  }),

  'Coupon or Voucher follow ups/early bird deadline - Set 2':
    Yup.object().shape({
      client_name: Yup.string().required('Client Name is required'),
      conference_short_name: Yup.string().required(
        'Conference Short Name is required'
      ),
      conference_location: Yup.string().required(
        'Conference Location is required'
      ),
      conference_from_date: Yup.date()
        .transform((value, originalValue) =>
          originalValue ? new Date(originalValue) : null
        )
        .required('Conference From Date is required'),
      conference_to_date: Yup.date()
        .transform((value, originalValue) =>
          originalValue ? new Date(originalValue) : null
        )
        .required('Conference To Date is required')
        .min(
          Yup.ref('conference_from_date'),
          'To Date cannot be before From Date'
        ),
      coupon_code: Yup.string().required('Coupon Code is required'),
      discount_amount: Yup.number()
        .typeError('Discount Amount must be a number')
        .positive('Discount Amount must be positive')
        .required('Discount Amount is required'),
      registration_link: Yup.string()
        .url('Must be a valid URL (e.g., https://example.com)')
        .required('Registration Link is required'),
      your_name: Yup.string().required('Your Name is required'),
      contact_details: Yup.string().required('Contact Details are required'),
      // .matches(
      //   /^[0-9+\-() ]+$/,
      //   'Contact Details must be a valid phone number'
      // ),
    }),

  'Coupon or Voucher follow ups/early bird deadline - Set 3':
    Yup.object().shape({
      client_name: Yup.string().required('Client Name is required'),
      conference_short_name: Yup.string().required(
        'Conference Short Name is required'
      ),
      registration_link: Yup.string()
        .url('Must be a valid URL (e.g., https://example.com)')
        .required('Registration Link is required'),

      // deadline_date: Yup.date()
      //   .transform((value, originalValue) =>
      //     originalValue ? new Date(originalValue) : null
      //   )
      //   .required('Deadline Date is required')
      //   .test(
      //     'not-in-past',
      //     'Deadline cannot be in the past',
      //     function (value) {
      //       if (!value) return true;
      //       const today = new Date().setHours(0, 0, 0, 0);
      //       const deadline = new Date(value).setHours(0, 0, 0, 0);
      //       return deadline >= today;
      //     }
      //   )
      //   .test('within-conference-dates', function (value) {
      //     const { conference_from_date, conference_to_date } = this.parent;
      //     if (!value || !conference_from_date || !conference_to_date)
      //       return true;

      //     const deadline = new Date(value).setHours(0, 0, 0, 0);
      //     const confStart = new Date(conference_from_date).setHours(0, 0, 0, 0);
      //     const confEnd = new Date(conference_to_date).setHours(0, 0, 0, 0);

      //     if (deadline < confStart || deadline > confEnd) {
      //       // Format dates for readability (e.g., "Jan 1, 2024")
      //       const startStr = new Date(conference_from_date).toLocaleDateString(
      //         'en-US',
      //         {
      //           year: 'numeric',
      //           month: 'short',
      //           day: 'numeric',
      //         }
      //       );
      //       const endStr = new Date(conference_to_date).toLocaleDateString(
      //         'en-US',
      //         {
      //           year: 'numeric',
      //           month: 'short',
      //           day: 'numeric',
      //         }
      //       );

      //       return this.createError({
      //         message: `Deadline must be between ${startStr} and ${endStr}`,
      //       });
      //     }
      //     return true;
      //   }),

      deadline_date: Yup.date()
        .nullable()
        .required('Deadline Date is required')
        .test(
          'is-within-date-range',
          'Deadline must be between Current date and the conference start date',
          function (value) {
            const { conference_from_date } = this.parent;

            if (!value || !conference_from_date) return true;
            const regDate = new Date(value).setHours(0, 0, 0, 0);
            const startDate = new Date(conference_from_date).setHours(
              0,
              0,
              0,
              0
            );
            const currentDate = new Date().setHours(0, 0, 0, 0);

            return regDate >= currentDate && regDate <= startDate;
          }
        ),
      your_name: Yup.string().required('Your Name is required'),
      contact_details: Yup.string().required('Contact Details are required'),
      // .matches(
      //   /^[0-9+\-() ]+$/,
      //   'Contact Details must be a valid phone number'
      // ),
    }),

  'Allotment of ISBN and ISSN Number': Yup.object().shape({
    client_name: Yup.string().required('Client Name is required'),
    conference_short_name: Yup.string().required(
      'Conference Short Name is required'
    ),
    conference_from_date: Yup.date()
      .transform((value, originalValue) =>
        originalValue ? new Date(originalValue) : null
      )
      .required('Conference From Date is required'),
    conference_to_date: Yup.date()
      .transform((value, originalValue) =>
        originalValue ? new Date(originalValue) : null
      )
      .required('Conference To Date is required')
      .min(
        Yup.ref('conference_from_date'),
        'To Date cannot be before From Date'
      ),
    registration_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Registration Link is required'),
    your_name: Yup.string().required('Your Name is required'),
    contact_details: Yup.string().required('Contact Details are required'),
    // .matches(
    //   /^[0-9+\-() ]+$/,
    //   'Contact Details must be a valid phone number'
    // ),
  }),

  'Visa-Free Projection': Yup.object().shape({
    client_name: Yup.string().required('Client Name is required'),
    conference_short_name: Yup.string().required(
      'Conference Short Name is required'
    ),
    country_name: Yup.string().required('Country Name is required'),
    visa_free_guide_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Visa-Free Guide Link is required'),
    registration_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Registration Link is required'),
    your_name: Yup.string().required('Your Name is required'),
    contact_details: Yup.string().required('Contact Details are required'),
    // .matches(
    //   /^[0-9+\-() ]+$/,
    //   'Contact Details must be a valid phone number'
    // ),
  }),

  'Scholarships & Awards Notification': Yup.object().shape({
    client_name: Yup.string().required('Recipient Name is required'),
    conference_short_name: Yup.string().required(
      'Conference Short Name is required'
    ),
    // deadline_date: Yup.date()
    //   .transform((value, originalValue) =>
    //     originalValue ? new Date(originalValue) : null
    //   )
    //   .required('Deadline Date is required'),

    deadline_date: Yup.date()
      .nullable()
      .required('Deadline Date is required')
      .test(
        'is-within-date-range',
        'Deadline must be between Current date and the conference start date',
        function (value) {
          const { conference_from_date } = this.parent;

          if (!value || !conference_from_date) return true;
          const regDate = new Date(value).setHours(0, 0, 0, 0);
          const startDate = new Date(conference_from_date).setHours(0, 0, 0, 0);
          const currentDate = new Date().setHours(0, 0, 0, 0);

          return regDate >= currentDate && regDate <= startDate;
        }
      ),

    scholarship_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Scholarship Link is required'),
    your_name: Yup.string().required('Your Name is required'),
    contact_details: Yup.string().required('Contact Details are required'),
    // .matches(
    //   /^[0-9+\-() ]+$/,
    //   'Contact Details must be a valid phone number'
    // ),
  }),

  'Pre-Conference Webinar Announcement': Yup.object().shape({
    client_name: Yup.string().required('Client Name is required'),
    speaker_name: Yup.string().required('Speaker Name is required'),
    webinar_date_time: Yup.date()
      .transform((value, originalValue) =>
        originalValue ? new Date(originalValue) : null
      )
      .required('Webinar Date & Time is required'),
    relevent_field_topic: Yup.string().required(
      'Relevant Field/Topic is required'
    ),
    conference_name: Yup.string().required('Conference Name is required'),
    registration_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Registration Link is required'),
  }),

  'Refer Your Colleagues': Yup.object().shape({
    client_name: Yup.string().required('Client Name is required'),
    conference_short_name: Yup.string().required(
      'Conference Short Name is required'
    ),
    registration_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Registration Link is required'),
    your_name: Yup.string().required('Your Name is required'),
    contact_details: Yup.string().required('Contact Details are required'),
  }),
  'Proceedings book Sales Follow up': Yup.object().shape({
    client_name: Yup.string().required('Client Name is required'),
    conference_short_name: Yup.string().required(
      'Conference Short Name is required'
    ),
    registration_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Registration Link is required'),
    your_name: Yup.string().required('Your Name is required'),
    contact_details: Yup.string().required('Contact Details are required'),
  }),

  'Awards sales Follow up': Yup.object().shape({
    client_name: Yup.string().required('Client Name is required'),
    conference_short_name: Yup.string().required(
      'Conference Short Name is required'
    ),
    registration_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Registration Link is required'),
    // deadline_date: Yup.date()
    //   .typeError('Deadline Date must be a valid date')
    //   .required('Deadline Date is required'),
    deadline_date: Yup.date()
      .nullable()
      .required('Deadline Date is required')
      .test(
        'is-within-date-range',
        'Deadline must be between current date and the conference start date',
        function (value) {
          const { conference_from_date } = this.parent;

          if (!value || !conference_from_date) return true;
          const regDate = new Date(value).setHours(0, 0, 0, 0);
          const startDate = new Date(conference_from_date).setHours(0, 0, 0, 0);
          const currentDate = new Date().setHours(0, 0, 0, 0);

          return regDate >= currentDate && regDate <= startDate;
        }
      ),
    your_name: Yup.string().required('Your Name is required'),
    contact_details: Yup.string().required('Contact Details are required'),
  }),

  'Proceedings book Sales Follow up': Yup.object().shape({
    client_name: Yup.string().required('Client Name is required'),
    conference_short_name: Yup.string().required(
      'Conference Short Name is required'
    ),
    registration_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Registration Link is required'),
    your_name: Yup.string().required('Your Name is required'),
    contact_details: Yup.string().required('Contact Details are required'),
  }),

  'Agenda Sales Follow up': Yup.object().shape({
    client_name: Yup.string().required('Client Name is required'),
    conference_short_name: Yup.string().required(
      'Conference Short Name is required'
    ),
    registration_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Registration Link is required'),
    your_name: Yup.string().required('Your Name is required'),
    contact_details: Yup.string().required('Contact Details are required'),
  }),

  'Final Thank You Email for unregistered participants': Yup.object().shape({
    client_name: Yup.string().required('Client Name is required'),
    conference_short_name: Yup.string().required(
      'Conference Short Name is required'
    ),
    photo_access_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Photo Access Link is required'),
    upcoming_conference_link: Yup.string()
      .url('Must be a valid URL (e.g., https://example.com)')
      .required('Upcoming Conference Link is required'),
    your_name: Yup.string().required('Your Name is required'),
    contact_details: Yup.string().required('Contact Details are required'),
  }),
  // Default empty validation for unknown steps
  default: Yup.object().shape({}),
};
